export const doctorsDemoData = [
  {
    title: "Dr. Varun Gogia (N1ct9d3hko)",
    slug: "dr-varun-gogia-n1ct9d3hko",
    acfData: {
      id: "N1ct9d3hko",
      main_category: "Ophthalmologist",
      cities: [
        {
          ID: 1856,
          post_title: "DELHI",
          post_name: "delhi",
          cityname: "Delhi",
        },
      ],
      personal_details: {
        name: "Dr. Varun Gogia",
        heading: "MBBS, MD",
        fees: "2000",
        rating: "4.9",
        speciality: "Ophthalmologist / Eye Surgeon",
        about:
          "Dr. Varun Gogia completed his entire medical training, MBBS, MD, and Senior Residency at AIIMS, Delhi (Dr. Rajendra Prasad Centre for Ophthalmic Sciences). He specializes in retina care, cataract, uveitis, ROP, and micro-vitrectomy systems. He was awarded Best Junior Resident at AIIMS and also topped the MD entrance exam at RPC. His research on posterior uveitis won him the Indian Journal of Ophthalmology Silver Award in 2016.\nOver the years, Dr. Gogia has made several surgical innovations, including techniques for treating retinal detachment, uveal melanoma, and serpiginous choroiditis. He has published more than 60 research papers and presented his work at more than 20 national and international conferences. Before joining Pristyn Care, he led the retina division at Medanta Hospital and played a key role in developing advanced retina treatments.",
        image:
          "https://img.pristyncare.com/Medical_Services_Dashboard/2024-12-03T16:48:12.824Z_1719465034402_ban-Icon.png/1733244491990_ban-Icon.png",
      },
      address_data: {
        id: "IjNmJjM5Yj",
        city: "Delhi",
        region_code: "110024",
        label_to_show:
          "26, National Park Rd, near Moolchand Metro station, Vikram Vihar, Lajpat Nagar IV, Lajpat Nagar, New Delhi, Delhi 110024",
        map_link: "https://maps.app.goo.gl/6AfCtNTcFg8yS6av9",
        latitude: "28.5616563",
        longitude: "77.2379748",
        doctor_clinic_appointment_slug: "Dr.-Varun-Gogia--IjNmJjM5Yj",
      },
      central_number: "8065417867",
      experience_details: {
        experience: "18 Years Experience Overall",
      },
      qualification_details: {
        qualifications: [
          {
            degree: "MBBS",
            institute: " ",
            year: "2007",
          },
        ],
      },
      is_visiting_doctor: false,
      is_active: true,
      diseases_covered: [
        "Eye Problem",
        "Macular Edema",
        "Pterygium",
        "Phaco Surgery",
        "PRK Lasik Surgery",
        "Toric Lens",
        "Contoura Vision",
        "SMILE LASIK Surgery",
        "Multifocal Lens",
        "Monofocal Lens",
        "ICL Surgery",
        "Femto LASIK Surgery",
        "Vitrectomy",
        "Intravitreal Injections",
        "Glaucoma Surgery",
        "Squint Surgery",
        "Lasik Surgery",
        "Lasik Eye Surgery",
        "Cataract Surgery",
      ],
      is_his_hospital_doctor: true,
      employee_code: "PL0075",
      his_hospital_ids: [],
      hospital_hotline_number: null,
      diseases_covered_slug: [
        "eye-problem",
        "macular-edema",
        "pterygium",
        "phaco-surgery",
        "prk-lasik-surgery",
        "toric-lens",
        "contoura-vision",
        "smile-lasik-surgery",
        "multifocal-lens",
        "monofocal-lens",
        "icl-surgery",
        "femto-lasik-surgery",
        "vitrectomy",
        "intravitreal-injections",
        "glaucoma",
        "squint",
        "lasik",
        "lasik-eye-surgery",
        "cataract",
      ],
      categories_list: ["ophthalmology"],
      categoriesSlug_list: ["eye-specialists"],
      doctor_page_path: "/specialist/dr-varun-gogia-n1ct9d3hko/",
      alternate_category_slug: "ophthalmologist",
      specialist_category_slug: "eye-specialists",
      totalReviews: 1,
      aggregateDoctorRealRating: "5.0",
    },
  },
  {
    title: "Dr. Prerana Tripathi (JTV8yKdDuO)",
    slug: "dr-prerana-tripathi-jtv8ykdduo",
    acfData: {
      id: "JTV8yKdDuO",
      main_category: "Ophthalmologist",
      cities: [
        {
          ID: 1869,
          post_title: "BANGALORE",
          post_name: "bangalore",
          cityname: "Bangalore",
        },
      ],
      personal_details: {
        name: "Dr. Prerana Tripathi",
        heading: "MBBS, DO, DNB - Ophthalmology",
        fees: "1000",
        rating: "4.6",
        speciality: "Ophthalmologist/ Eye Surgeon",
        about:
          "Dr. Prerana Tripathi is a Ophthalmologist/ Eye Surgeon in Malleswaram, Bangalore and has an experience of 15+ years as a medical practitioner. Dr. Prerana Tripathi practices at Pristyn Care in Malleswaram, Bangalore. She completed MBBS from Rajiv Gandhi University of Health Sciences in 2009, DO from Madurai Medical College in 2015 and DNB - Ophthalmology from National Board of Education, New Delhi in 2017. \n Some of the services provided by the doctor are: Nystagmus, Laser Procedures for Retina, Eye Infection, Stringy Eye Discharge and Entropion etc.",
        image:
          "https://img.pristyncare.com/our%20doctors%2FAvatar%2FPreranaTripathi.jpg",
      },
      address_data: {
        id: "EmZzAjNlRj",
        city: "Bangalore",
        region_code: "560038",
        label_to_show:
          "31, 80 Feet Rd, Hal, HAL 3rd Stage, Indiranagar, Bengaluru, Karnataka 560038",
        map_link: "https://maps.google.com/maps?cid=7864526061565747478",
        latitude: "12.971573",
        longitude: "77.6473848",
        doctor_clinic_appointment_slug: "Dr.-Prerana-Tripathi--EmZzAjNlRj",
      },
      central_number: "919311583422",
      experience_details: {
        experience: "16 Years Experience Overall",
      },
      qualification_details: {
        qualifications: [
          {
            degree: "MBBS",
            institute: "Rajiv Gandhi University of Health Sciences, Karnataka",
            year: "2009",
          },
          {
            degree: "Diploma in Ophthalmology",
            institute: "The Tamil Nadu Dr. MGR Medical University, Chennai",
            year: "2015",
          },
          {
            degree: "DNB",
            institute: "National Board of Examinations ",
            year: "2018",
          },
        ],
      },
      is_visiting_doctor: false,
      is_active: true,
      diseases_covered: [
        "Eye Problem",
        "Macular Edema",
        "Pterygium",
        "Phaco Surgery",
        "PRK Lasik Surgery",
        "Toric Lens",
        "Contoura Vision",
        "SMILE LASIK Surgery",
        "Multifocal Lens",
        "Monofocal Lens",
        "ICL Surgery",
        "Femto LASIK Surgery",
        "Vitrectomy",
        "Intravitreal Injections",
        "Glaucoma Surgery",
        "Squint Surgery",
        "Lasik Surgery",
        "Lasik Eye Surgery",
        "Cataract Surgery",
      ],
      is_his_hospital_doctor: true,
      employee_code: "DPC239",
      his_hospital_ids: [],
      hospital_hotline_number: null,
      diseases_covered_slug: [
        "eye-problem",
        "macular-edema",
        "pterygium",
        "phaco-surgery",
        "prk-lasik-surgery",
        "toric-lens",
        "contoura-vision",
        "smile-lasik-surgery",
        "multifocal-lens",
        "monofocal-lens",
        "icl-surgery",
        "femto-lasik-surgery",
        "vitrectomy",
        "intravitreal-injections",
        "glaucoma",
        "squint",
        "lasik",
        "lasik-eye-surgery",
        "cataract",
      ],
      categories_list: ["ophthalmology"],
      categoriesSlug_list: ["eye-specialists"],
      doctor_page_path: "/specialist/dr-prerana-tripathi-jtv8ykdduo/",
      alternate_category_slug: "ophthalmologist",
      specialist_category_slug: "eye-specialists",
      totalReviews: 6,
      aggregateDoctorRealRating: "4.8",
    },
  },
  {
    title: "Dr. Chanchal Gadodiya (569YKXVNqG)",
    slug: "dr-chanchal-gadodiya-569ykxvnqg",
    acfData: {
      id: "569YKXVNqG",
      main_category: "Ophthalmologist",
      cities: [
        {
          ID: 1867,
          post_title: "PUNE",
          post_name: "pune",
          cityname: "Pune",
        },
      ],
      personal_details: {
        name: "Dr. Chanchal Gadodiya",
        heading: "MS, DNB, FICO, MRCS, Fellow Paediatric Opth",
        fees: "800",
        rating: "4.5",
        speciality: "Ophthalmologist, Eye Surgeon",
        about:
          "Dr. Chanchal Gadodiya is an expert and experienced Ophthalmologist and Eye Surgeon with an experience of 11+ years, and specialises in Ophthalmology. She graduated and obtained her MBBS degree from B J Medical College, Pune. (Maharashtra Universities of health and Sciences) in 2013, and then her postgraduate MS degree from B J Medical College, Pune. (Maharashtra Universities of health and Sciences) in 2016.Currently, she is practicing at Pristyn Care Clinic in Pune. She is fluent in English and Hindi and provides compassionate care for all her patients to ensure complete recovery. She has been commended by her patients for her caring nature, hard working attitude, and willingness to be there for them - any time of day and night.She provides treatment for the following - Ophthalmology, Indian Monofocal Cataract, Indian Multifocal Cataract, Foreign Monofocal Cataract, Foreign Multifocal Cataract, Squint, Trifocal Indian Cataract, Trifocal Foreign Cataract, Monofocal Indian Toric Cataract, Monofocal Foreign Toric Cataract, Multifocal Indian Toric Cataract, Multifocal Foreign Toric Cataract, Trifocal Indian Toric Cataract, Trifocal Foreign Toric Cataract, C3R, Pterygium, and other conditions. She is registered in the Indian Medical Registry with the license number 2013051627. She strives to provide advanced medical care in a comfortable and holistic environment for all patients coming to her for treatment.",
        image:
          "https://img.pristyncare.com/our%20doctors%2FAvatar%2FChanchal.jpg",
      },
      address_data: {
        id: "ImZ4kDZmNj",
        city: "Pune",
        region_code: "411004",
        label_to_show:
          "GRCW+76R, Jangali Maharaj Road Dealing Corner, Shivajinagar, Pune, Maharashtra 411004",
        map_link: "https://maps.google.com/maps?cid=4860619807627542244",
        latitude: "18.5194002",
        longitude: "73.8452827",
        doctor_clinic_appointment_slug: "Dr.-Chanchal-Gadodiya--ImZ4kDZmNj",
      },
      central_number: "919311583422",
      experience_details: {
        experience: "12 Years Experience Overall",
      },
      qualification_details: {
        qualifications: [
          {
            degree: "MBBS",
            institute: "B J Medical College, Pune",
            year: "2013",
          },
          {
            degree: "MS - Ophthalmology",
            institute: "B Y L Nair Hospital, Mumbai",
            year: "2016",
          },
          {
            degree: "DNB",
            institute: "National Board of Examination, Delhi",
            year: "2017",
          },
        ],
      },
      is_visiting_doctor: false,
      is_active: true,
      diseases_covered: [
        "Eye Problem",
        "Macular Edema",
        "Pterygium",
        "Phaco Surgery",
        "PRK Lasik Surgery",
        "Toric Lens",
        "Contoura Vision",
        "SMILE LASIK Surgery",
        "Multifocal Lens",
        "Monofocal Lens",
        "ICL Surgery",
        "Femto LASIK Surgery",
        "Vitrectomy",
        "Intravitreal Injections",
        "Glaucoma Surgery",
        "Squint Surgery",
        "Lasik Surgery",
        "Lasik Eye Surgery",
        "Cataract Surgery",
      ],
      is_his_hospital_doctor: true,
      employee_code: "DPC812",
      his_hospital_ids: [],
      hospital_hotline_number: null,
      diseases_covered_slug: [
        "eye-problem",
        "macular-edema",
        "pterygium",
        "phaco-surgery",
        "prk-lasik-surgery",
        "toric-lens",
        "contoura-vision",
        "smile-lasik-surgery",
        "multifocal-lens",
        "monofocal-lens",
        "icl-surgery",
        "femto-lasik-surgery",
        "vitrectomy",
        "intravitreal-injections",
        "glaucoma",
        "squint",
        "lasik",
        "lasik-eye-surgery",
        "cataract",
      ],
      categories_list: ["ophthalmology"],
      categoriesSlug_list: ["eye-specialists"],
      doctor_page_path: "/specialist/dr-chanchal-gadodiya-569ykxvnqg/",
      alternate_category_slug: "ophthalmologist",
      specialist_category_slug: "eye-specialists",
      totalReviews: 5,
      aggregateDoctorRealRating: "4.8",
    },
  },
  {
    title: "Dr. Barkha Gupta (2Fc4jogG0q)",
    slug: "dr-barkha-gupta-2fc4jogg0q",
    acfData: {
      id: "2Fc4jogG0q",
      main_category: "Ophthalmologist",
      cities: [
        {
          ID: 1856,
          post_title: "DELHI",
          post_name: "delhi",
          cityname: "Delhi",
        },
      ],
      personal_details: {
        name: "Dr. Barkha Gupta",
        heading: "MBBS, MD-Ophthalmology",
        fees: "700",
        rating: "4.8",
        speciality: "Ophthalmologist",
        about:
          "Dr. Barkha Gupta is an expert and experienced Ophthalmologist with specialized training in Cornea, Cataract, and Refractive Surgery. She holds an MBBS, an MD in Ophthalmology from the prestigious AIIMS, New Delhi, and an M.Ch in Cornea, Cataract, and Refractive Surgery from PGIMER, Chandigarh. Additionally, she is a Fellow of the International Council of Ophthalmology (FICO). With a strong academic foundation and clinical expertise, she brings cutting-edge care to patients with complex corneal disorders, cataracts, and vision correction needs.\n\nDr. Barkha is highly skilled in performing advanced ophthalmic procedures, including phacoemulsification, LASIK, SMILE, and corneal transplants. Her surgical precision and patient-first approach have made her a trusted name in the field. She has been a part of multiple national and international conferences and has published research in reputed journals, contributing significantly to the field of ophthalmology. Her areas of interest also include keratoconus management, dry eye treatment, and customized refractive correction.\n\nA committed clinician and innovator, Dr. Barkha is an active member of leading professional organizations like the All India Ophthalmological Society (AIOS). She continuously strives to integrate the latest technologies and evidence-based practices into her clinical work. Her dedication to restoring and enhancing vision has improved the quality of life for countless patients, making her one of the most promising specialists in her field.",
        image:
          "https://img.pristyncare.com/Medical_Services_Dashboard/2025-05-13T07:55:29.267Z_DR-BARKHA-GUPTA-app 2.jpg/1747122929704_ban-Icon.png",
      },
      address_data: {
        id: "EjMwUzMzcj",
        city: "Delhi",
        region_code: "110058",
        label_to_show: "C-2/390, Pankha Rd, C4 D Block, Janakpuri",
        map_link: "https://maps.google.com/maps?cid=8383306099896199580",
        latitude: "28.6150111",
        longitude: "77.0838947",
        doctor_clinic_appointment_slug: "Dr.-Barkha-Gupta--EjMwUzMzcj",
      },
      central_number: "8065417867",
      experience_details: {
        experience: "9 Years Experience Overall",
      },
      qualification_details: {
        qualifications: [
          {
            degree: "MBBS",
            institute:
              "Pandit Bhagwat Dayal Sharma University of Health Sciences, Rohtak",
            year: "2016",
          },
          {
            degree: "MD- Ophthalmology",
            institute: "All India Institute of Medical Sciences, New Delhi",
            year: "2019",
          },
        ],
      },
      is_visiting_doctor: false,
      is_active: true,
      diseases_covered: [
        "Eye Problem",
        "Macular Edema",
        "Keratoconus",
        "Pterygium",
        "Phaco Surgery",
        "Toric Lens",
        "Multifocal Lens",
        "Monofocal Lens",
        "Vitrectomy",
        "Intravitreal Injections",
        "Glaucoma Surgery",
        "Squint Surgery",
        "Cataract Surgery",
      ],
      is_his_hospital_doctor: false,
      employee_code: "OH0009",
      his_hospital_ids: [],
      hospital_hotline_number: null,
      diseases_covered_slug: [
        "eye-problem",
        "macular-edema",
        "keratoconus",
        "pterygium",
        "phaco-surgery",
        "toric-lens",
        "multifocal-lens",
        "monofocal-lens",
        "vitrectomy",
        "intravitreal-injections",
        "glaucoma",
        "squint",
        "cataract",
      ],
      categories_list: ["ophthalmology"],
      categoriesSlug_list: ["eye-specialists"],
      doctor_page_path: "/specialist/dr-barkha-gupta-2fc4jogg0q/",
      alternate_category_slug: "ophthalmologist",
      specialist_category_slug: "eye-specialists",
      totalReviews: 0,
      aggregateDoctorRealRating: 4.6,
    },
  },
  {
    title: "Dr. Vitthal Gulab Satav (MQBZCcnPys)",
    slug: "dr-vitthal-gulab-satav-mqbzccnpys",
    acfData: {
      id: "MQBZCcnPys",
      main_category: "Ophthalmologist",
      cities: [
        {
          ID: 1867,
          post_title: "PUNE",
          post_name: "pune",
          cityname: "Pune",
        },
      ],
      personal_details: {
        name: "Dr. Vitthal Gulab Satav",
        heading: "MBBS, Diploma in Ophthalmology",
        fees: "500",
        rating: "4.7",
        speciality: "Ophthalmologist/Eye Surgeon",
        about:
          "Dr. Vitthal G. Satav is an expert and experienced Ophthalmologist and Phaco-Refractive Surgeon with an experience of 22 years. He specializes in cataract and refractive surgeries, having successfully performed over 50,000 surgeries to date. Dr. Satav is recognized for pioneering advanced techniques like the 1.8 mm micro-phacoemulsification technique for cataract surgery and Multifocal & Accommodative intraocular lens implantation. His expertise and dedication have earned him recognition as one of the leading eye surgeons in Pune.\n\nDr. Satav holds an MBBS and D.O.M.S qualification and is registered with the Maharashtra Medical Council under registration number 81682. He served as the Director at Aakash Eye Clinic & Laser Center with branches in Viman Nagar and Chandan Nagar, Pune, where he provided exemplary eye care services. Dr. Satav has been honored for his contributions to ophthalmology, notably receiving an award for Best Eye Doctor from Anna Hazare. His work has also been recognized through his presentations, such as the paper on Satisfaction in Multifocal IOL at MOSCON 2018 and his instructional course on Refractive Surgery at MOSCON 2019.\n\nDr. Vitthal G. Satav now joined Pristyn Care, where he continues to provide advanced and compassionate care for a wide range of ocular conditions. He is fluent in English and Hindi, ensuring effective communication and a patient-centric approach. With his extensive experience and accolades, Dr. Satav is committed to delivering the highest standards of eye care to improve the vision and lives of his patients.",
        image:
          "https://img.pristyncare.com/Medical_Services_Dashboard/2024-12-17T05:04:03.283Z_Dr.-Vitthal-Gulab-Satav-app 3.jpg/1734411843622_ban-Icon.png",
      },
      address_data: {
        id: "MmYmNjM3cj",
        city: "Pune",
        region_code: "411014",
        label_to_show: "City Space, Office 113–115, Nagar Rd, Viman Nagar",
        map_link: "https://maps.app.goo.gl/ypUNHjPmEcqXt9By8",
        latitude: "18.5627785",
        longitude: "73.9222416",
        doctor_clinic_appointment_slug: "Dr.-Vitthal-Gulab-Satav--MmYmNjM3cj",
      },
      central_number: "8527488190",
      experience_details: {
        experience: "30 Years Experience Overall",
      },
      qualification_details: {
        qualifications: [
          {
            degree: "MBBS",
            institute: "University of Pune",
            year: "1995",
          },
          {
            degree: "Diploma in Ophthalmology",
            institute: "University of Pune",
            year: "1999",
          },
        ],
      },
      is_visiting_doctor: true,
      is_active: true,
      diseases_covered: [
        "Eye Problem",
        "Macular Edema",
        "Keratoconus",
        "Pterygium",
        "Phaco Surgery",
        "PRK Lasik Surgery",
        "Toric Lens",
        "Contoura Vision",
        "SMILE LASIK Surgery",
        "Multifocal Lens",
        "Monofocal Lens",
        "ICL Surgery",
        "Femto LASIK Surgery",
        "Vitrectomy",
        "Intravitreal Injections",
        "Glaucoma Surgery",
        "Squint Surgery",
        "Lasik Surgery",
        "Lasik Eye Surgery",
        "Cataract Surgery",
      ],
      is_his_hospital_doctor: false,
      employee_code: "DPC2158",
      his_hospital_ids: [],
      hospital_hotline_number: null,
      diseases_covered_slug: [
        "eye-problem",
        "macular-edema",
        "keratoconus",
        "pterygium",
        "phaco-surgery",
        "prk-lasik-surgery",
        "toric-lens",
        "contoura-vision",
        "smile-lasik-surgery",
        "multifocal-lens",
        "monofocal-lens",
        "icl-surgery",
        "femto-lasik-surgery",
        "vitrectomy",
        "intravitreal-injections",
        "glaucoma",
        "squint",
        "lasik",
        "lasik-eye-surgery",
        "cataract",
      ],
      categories_list: ["ophthalmology"],
      categoriesSlug_list: ["eye-specialists"],
      doctor_page_path: "/specialist/dr-vitthal-gulab-satav-mqbzccnpys/",
      alternate_category_slug: "ophthalmologist",
      specialist_category_slug: "eye-specialists",
      totalReviews: 0,
      aggregateDoctorRealRating: 4.6,
    },
  },
  {
    title: "Dr. Tushara Aluri (GKxcGEGDHn)",
    slug: "dr-tushara-aluri-gkxcgegdhn",
    acfData: {
      id: "GKxcGEGDHn",
      main_category: "Ophthalmologist",
      cities: [
        {
          ID: 1876,
          post_title: "HYDERABAD",
          post_name: "hyderabad",
          cityname: "Hyderabad",
        },
      ],
      personal_details: {
        name: "Dr. Tushara Aluri",
        heading: "MBBS, DO-Ophthalmology",
        fees: "500",
        rating: "4.6",
        speciality: "Ophthalmologist, Eye Surgeon",
        about:
          "Dr. Tushara Aluri is an expert and experienced Ophthalmologist and Eye Surgeon with an experience of 22+ years, and specializes in Ophthalmology. She graduated and obtained her MBBS degree from Rangaraya Medical college, Kakinada in 1996, and then her postgraduate DO degree from Rangaraya Medical college, Kakinada in 2006. Currently, she is practicing at Pristyn Care Clinic in Hyderabad. She is fluent in English and Hindi and provides compassionate care for all her patients to ensure complete recovery. She has been commended by her patients for her caring nature, hard working attitude, and willingness to be there for them - any time of day and night. She provides treatment for the following - Indian Monofocal Cataract, Lasik, Indian Multifocal Cataract, Foreign Monofocal Cataract, Foreign Multifocal Cataract, Squint, Trifocal Indian Cataract, Trifocal Foreign Cataract, Monofocal Indian Toric Cataract, Monofocal Foreign Toric Cataract, Multifocal Indian Toric Cataract, Multifocal Foreign Toric Cataract, Trifocal Indian Toric Cataract, Trifocal Foreign Toric Cataract, Pterygium, and other conditions. She is registered in the Indian Medical Registry with the license number 40722. She strives to provide advanced medical care in a comfortable and holistic environment for all patients coming to her for treatment.",
        image:
          "https://img.pristyncare.com/Medical_Services_Dashboard/2024-07-24T14:25:50.075Z_WhatsApp Image 2024-07-24 at 19.40.08.jpeg/1721831151416_ban-Icon.png",
      },
      address_data: {
        id: "",
        city: "Hyderabad",
        region_code: "",
        label_to_show: "",
        map_link: "",
        latitude: "",
        longitude: "",
      },
      central_number: "7353240999",
      experience_details: {
        experience: "29 Years Experience Overall",
      },
      qualification_details: {
        qualifications: [
          {
            degree: "MBBS",
            institute: "Rangaraya Medical college, Kakinada",
            year: "1996",
          },
          {
            degree: "Diploma in Ophthalmology",
            institute: "Rangaraya Medical college, Kakinada",
            year: "2006",
          },
        ],
      },
      is_visiting_doctor: true,
      is_active: true,
      diseases_covered: [
        "Eye Problem",
        "Macular Edema",
        "Pterygium",
        "Phaco Surgery",
        "Toric Lens",
        "Multifocal Lens",
        "Monofocal Lens",
        "Vitrectomy",
        "Intravitreal Injections",
        "Glaucoma Surgery",
        "Squint Surgery",
        "Cataract Surgery",
      ],
      is_his_hospital_doctor: false,
      employee_code: "DPC2046",
      his_hospital_ids: [],
      hospital_hotline_number: null,
      diseases_covered_slug: [
        "eye-problem",
        "macular-edema",
        "pterygium",
        "phaco-surgery",
        "toric-lens",
        "multifocal-lens",
        "monofocal-lens",
        "vitrectomy",
        "intravitreal-injections",
        "glaucoma",
        "squint",
        "cataract",
      ],
      categories_list: ["ophthalmology"],
      categoriesSlug_list: ["eye-specialists"],
      doctor_page_path: "/specialist/dr-tushara-aluri-gkxcgegdhn/",
      alternate_category_slug: "ophthalmologist",
      specialist_category_slug: "eye-specialists",
      totalReviews: 0,
      aggregateDoctorRealRating: 4.6,
    },
  },
  {
    title: "Dr. S Geetha (yyorDpAp6S)",
    slug: "dr-s-geetha-yyordpap6s",
    acfData: {
      id: "yyorDpAp6S",
      main_category: "Ophthalmologist",
      cities: [
        {
          ID: 1869,
          post_title: "BANGALORE",
          post_name: "bangalore",
          cityname: "Bangalore",
        },
      ],
      personal_details: {
        name: "Dr. S Geetha",
        heading: "MBBS, DO-Ophthalmology, DNB-Ophthalmology",
        fees: "500",
        rating: "4.5",
        speciality: "Ophthalmologist",
        about:
          "Dr Geetha S is an Ophthalmology Consultant having more than 20 years of experience. She is a specialist in the field of Ophthalmology and expertise in Phacoemulsification with IOL implants. She has done MBBS from Devaraj Urs Medical College, Kolar. Dr Geetha has also completed Diploma in Ophthalmic Medicine and Surgery from Vijayanagara Institute of Medical Sciences, Bellary. She has acquired Diplomate of National Board from Prabha Eye Clinic & Research Centre. Dr Geetha has been trained at Susheela Netralaya, Kurnool as well as Medical Retina Short Term Fellowship in Retinal Lasers from L.V. Prasad Institute, Hyderabad. Dr Geetha has been awarded for Annual Participation and Attendance at All India Ophthalmic Conference. She is a lifetime member of Karnataka Ophthalmic Society and All India Ophthalmic Society. Currently she practices at Pristyn Care Clinic, Bangalore.",
        image:
          "https://img.pristyncare.com/Medical_Services_Dashboard/2025-02-05T07:00:11.510Z_Dr.-S-Geetha_app 2.jpg/1738738811761_ban-Icon.png",
      },
      address_data: {
        id: "EGNklTOjdj",
        city: "Bangalore",
        region_code: "560077",
        label_to_show: "502, Thanisandra Main Rd, RK Hegde Nagar",
        map_link: "https://maps.app.goo.gl/z1WkzVbRaF4V3eAF8",
        latitude: "13.0584117",
        longitude: "77.632867",
        doctor_clinic_appointment_slug: "Dr.-S-Geetha--EGNklTOjdj",
      },
      central_number: "6366447380",
      experience_details: {
        experience: "29 Years Experience Overall",
      },
      qualification_details: {
        qualifications: [
          {
            degree: "MBBS",
            institute: "Sri Devaraj Urs Medical College, Tamaka, Kolar",
            year: "1996",
          },
          {
            degree: "Diploma in Ophthalmology",
            institute: "Rajiv Gandhi University of Health Sciences, Karnataka",
            year: "2001",
          },
          {
            degree: "DNB ophthalmology",
            institute: "National Board of Examinations, New Delhi, India",
            year: "2004",
          },
        ],
      },
      is_visiting_doctor: true,
      is_active: true,
      diseases_covered: [
        "Eye Problem",
        "Macular Edema",
        "Pterygium",
        "Phaco Surgery",
        "Toric Lens",
        "Multifocal Lens",
        "Monofocal Lens",
        "Vitrectomy",
        "Intravitreal Injections",
        "Glaucoma Surgery",
        "Squint Surgery",
        "Cataract Surgery",
      ],
      is_his_hospital_doctor: false,
      employee_code: "DPC2207",
      his_hospital_ids: [],
      hospital_hotline_number: null,
      diseases_covered_slug: [
        "eye-problem",
        "macular-edema",
        "pterygium",
        "phaco-surgery",
        "toric-lens",
        "multifocal-lens",
        "monofocal-lens",
        "vitrectomy",
        "intravitreal-injections",
        "glaucoma",
        "squint",
        "cataract",
      ],
      categories_list: ["ophthalmology"],
      categoriesSlug_list: ["eye-specialists"],
      doctor_page_path: "/specialist/dr-s-geetha-yyordpap6s/",
      alternate_category_slug: "ophthalmologist",
      specialist_category_slug: "eye-specialists",
      totalReviews: 0,
      aggregateDoctorRealRating: 4.6,
    },
  },
  {
    title: "Dr. Sirish Nelivigi (7ghRBRs09C)",
    slug: "dr-sirish-nelivigi-7ghrbrs09c",
    acfData: {
      id: "7ghRBRs09C",
      main_category: "Ophthalmologist",
      cities: [
        {
          ID: 1869,
          post_title: "BANGALORE",
          post_name: "bangalore",
          cityname: "Bangalore",
        },
      ],
      personal_details: {
        name: "Dr. Sirish Nelivigi",
        heading: "MBBS, DO, DNB-Ophthalmology",
        fees: "500",
        rating: "4.8",
        speciality: "Ophthalmologist/ Eye Surgeon",
        about:
          "Dr. Sirish Nelivigi is an expert and experienced Ophthalmologist/ Eye Surgeon. He specializes in Ophthalmology. He graduated and obtained his MBBS degree from JJM Medical College, Davangere in 1996, and then his postgraduate DO degree from Kasturba Medical College, Mangalore in 1999, DNB-Ophthalmologist in 2001 from National Board of Examinations New Delhi. .Currently, he is practicing at Pristyn Care Clinic in Bangalore. He is fluent in English and Hindi and provides compassionate care for all his patients to ensure complete recovery. He has been commended by his patients for his caring nature, hard working attitude, and willingness to be there for them - any time of day and night.He provides treatment for the following - Indian Monofocal Cataract, Lasik, Indian Multifocal Cataract, Foreign Monofocal Cataract, Foreign Multifocal Cataract, Squint, Trifocal Indian Cataract, Trifocal Foreign Cataract, Monofocal Indian Toric Cataract, Monofocal Foreign Toric Cataract, Multifocal Indian Toric Cataract, Multifocal Foreign Toric Cataract, Trifocal Indian Toric Cataract, Trifocal Foreign Toric Cataract, and Pterygium. He is registered in the Indian Medical Registry with the license number 43715. He strives to provide advanced medical care in a comfortable and holistic environment for all patients coming to him for treatment.",
        image:
          "https://img.pristyncare.com/Medical_Services_Dashboard/2024-11-30T11:45:35.517Z_Dr.-Sirish-Nelivigi 2.jpg/1732967136598_ban-Icon.png",
      },
      address_data: {
        id: "",
        city: "Bangalore",
        region_code: "",
        label_to_show: "",
        map_link: "",
        latitude: "",
        longitude: "",
      },
      central_number: "8065417867",
      experience_details: {
        experience: "29 Years Experience Overall",
      },
      qualification_details: {
        qualifications: [
          {
            degree: "MBBS",
            institute: "JJM Medical College, Davangere",
            year: "1996",
          },
          {
            degree: "Diploma in Ophthalmology",
            institute: "Kasturba Medical College, Mangalore",
            year: "1999",
          },
          {
            degree: "DNB ophthalmology",
            institute: "National Board of Examinations, New Delhi",
            year: "2001",
          },
        ],
      },
      is_visiting_doctor: true,
      is_active: true,
      diseases_covered: [
        "PRK Lasik Surgery",
        "Contoura Vision",
        "SMILE LASIK Surgery",
        "ICL Surgery",
        "Femto LASIK Surgery",
        "Vitrectomy",
        "Glaucoma Surgery",
        "Lasik Surgery",
        "Lasik Eye Surgery",
      ],
      is_his_hospital_doctor: false,
      employee_code: "DPC2140",
      his_hospital_ids: [],
      hospital_hotline_number: null,
      diseases_covered_slug: [
        "prk-lasik-surgery",
        "contoura-vision",
        "smile-lasik-surgery",
        "icl-surgery",
        "femto-lasik-surgery",
        "vitrectomy",
        "glaucoma",
        "lasik",
        "lasik-eye-surgery",
      ],
      categories_list: ["ophthalmology"],
      categoriesSlug_list: ["eye-specialists"],
      doctor_page_path: "/specialist/dr-sirish-nelivigi-7ghrbrs09c/",
      alternate_category_slug: "ophthalmologist",
      specialist_category_slug: "eye-specialists",
      totalReviews: 0,
      aggregateDoctorRealRating: 4.6,
    },
  },
  {
    title: "Dr. Anand Doraiswamy (9sc2AzCgpN)",
    slug: "dr-anand-doraiswamy-9sc2azcgpn",
    acfData: {
      id: "9sc2AzCgpN",
      main_category: "Ophthalmologist",
      cities: [
        {
          ID: 1869,
          post_title: "BANGALORE",
          post_name: "bangalore",
          cityname: "Bangalore",
        },
      ],
      personal_details: {
        name: "Dr. Anand Doraiswamy",
        heading: "MBBS, MS-Ophthalmology, DNB",
        fees: "500",
        rating: "4.9",
        speciality: "Ophthalmologist/Eye Surgeon",
        about:
          "Dr. Anand Doraiswamy is an accomplished and experienced Ophthalmologist with years of expertise in advanced eye care. Dr. Doraiswamy has demonstrated exceptional leadership and clinical skills in providing comprehensive eye care services. Before this, he was a Senior Consultant at Vasan Eye Care Hospital, Rajajinagar, Bangalore, where he served with distinction for 15 years, from February 2008 to March 2023.\n\nDr. Doraiswamy’s academic foundation is rooted in excellence. He earned his MBBS from Bangalore Medical College and Research Institute in 1996 and pursued an MS in Ophthalmology from KMC Mangalore, completing it in 2001. He further specialized in Cornea with a fellowship at the prestigious Sankara Nethralaya, Chennai, from 2001 to 2003.\n\nWith a keen focus on Refractive Surgery, Cataract Surgery, and other advanced eye procedures, Dr. Doraiswamy combines his surgical expertise with a patient-centric approach. His dedication to enhancing vision and improving quality of life has earned him recognition as a trusted specialist in his field. Dr. Doraiswamy continues to provide cutting-edge treatments in a compassionate and personalized manner. He practices at Pristyn Care Clinic, Bangalore.",
        image:
          "https://img.pristyncare.com/Medical_Services_Dashboard/2025-01-01T06:01:32.659Z_Dr.-Anand-Doraiswamy_app 2.jpg/1735711293522_ban-Icon.png",
      },
      address_data: {
        id: "ATYhhzN3cj",
        city: "Bangalore",
        region_code: "560086",
        label_to_show: "1. 711, A Square, Dr MC Modi Rd, Basaveshwar Nagar",
        map_link: "https://maps.app.goo.gl/WejeEyAxorchgwh19",
        latitude: "12.9975275",
        longitude: "77.5454893",
        doctor_clinic_appointment_slug: "Dr.-Anand-Doraiswamy--ATYhhzN3cj",
      },
      central_number: "8527488190",
      experience_details: {
        experience: "29 Years Experience Overall",
      },
      qualification_details: {
        qualifications: [
          {
            degree: "MBBS",
            institute: "Bangalore University",
            year: "1996",
          },
          {
            degree: "MS - Ophthalmology",
            institute: "Manipal Academy of Higher Education",
            year: "2001",
          },
          {
            degree: "DNB ophthalmology",
            institute: "National Board of Examinations, New Delhi",
            year: "2002",
          },
        ],
      },
      is_visiting_doctor: true,
      is_active: true,
      diseases_covered: [
        "Eye Problem",
        "Macular Edema",
        "Pterygium",
        "Phaco Surgery",
        "Toric Lens",
        "Multifocal Lens",
        "Monofocal Lens",
        "Vitrectomy",
        "Intravitreal Injections",
        "Glaucoma Surgery",
        "Squint Surgery",
        "Cataract Surgery",
      ],
      is_his_hospital_doctor: false,
      employee_code: "DPC2169",
      his_hospital_ids: [],
      hospital_hotline_number: null,
      diseases_covered_slug: [
        "eye-problem",
        "macular-edema",
        "pterygium",
        "phaco-surgery",
        "toric-lens",
        "multifocal-lens",
        "monofocal-lens",
        "vitrectomy",
        "intravitreal-injections",
        "glaucoma",
        "squint",
        "cataract",
      ],
      categories_list: ["ophthalmology"],
      categoriesSlug_list: ["eye-specialists"],
      doctor_page_path: "/specialist/dr-anand-doraiswamy-9sc2azcgpn/",
      alternate_category_slug: "ophthalmologist",
      specialist_category_slug: "eye-specialists",
      totalReviews: 1,
      aggregateDoctorRealRating: "5.0",
    },
  },
  {
    title: "Dr. Prakash Kumar Jain (EfRHoSIcrM)",
    slug: "dr-prakash-kumar-jain-efrhosicrm",
    acfData: {
      id: "EfRHoSIcrM",
      main_category: "Ophthalmologist",
      cities: [
        {
          ID: 1869,
          post_title: "BANGALORE",
          post_name: "bangalore",
          cityname: "Bangalore",
        },
      ],
      personal_details: {
        name: "Dr. Prakash Kumar Jain",
        heading: "MBBS, DNB-Ophthalmology",
        fees: "500",
        rating: "4.5",
        speciality: "Ophthalmologist",
        about:
          "Dr. Prakash Kumar Jain is an expert and experienced Ophthalmologist with decades of clinical and surgical experience. He holds an MBBS from Silchar Medical College, Assam, a Diploma in Ophthalmology (DO) from KMC Manipal, and a DNB in Ophthalmology from Sri Sankaradeva Nethralaya, Guwahati. Further enhancing his expertise, he obtained a Fellowship from the Royal College of Surgeons (FRCS), Glasgow, UK, along with specialized training in Glaucoma from Arvind Eye Hospital and Retina & Glaucoma from Moorfields Eye Hospital, London, UK.\n\nOver the years, Dr. Jain has worked alongside eminent ophthalmologists across Karnataka and beyond. He has mastered advanced procedures like Phacoemulsification, MICS (Micro Incision Cataract Surgery), Refractive Surgeries, Cosmetic Eye Dr. Prakash Kumar Jain is an expert and experienced Ophthalmologist with decades of clinical and surgical experience. He holds an MBBS from Silchar Medical College, Assam, a Diploma in Ophthalmology (DO) from KMC Manipal, and a DNB in Ophthalmology from Sri Sankaradeva Nethralaya, Guwahati. Further enhancing his expertise, he obtained a Fellowship from the Royal College of Surgeons (FRCS), Glasgow, UK, along with specialized training in Glaucoma from Arvind Eye Hospital and Retina & Glaucoma from Moorfields Eye Hospital, London, UK.\n\nOver the years, Dr. Jain has worked alongside eminent ophthalmologists across Karnataka and beyond. He has mastered advanced procedures like Phacoemulsification, MICS (Micro Incision Cataract Surgery), Refractive Surgeries, Cosmetic Eye Surgeries, and Glaucoma interventions. Under his leadership, Divyadrishti Eye Hospital introduced cutting-edge, patient-friendly surgical techniques such as No Anesthesia, No Bandage, and Bloodless Cataract Surgeries, simplifying complex procedures and improving patient outcomes significantly.\nDr. Jain has been instrumental in making advanced, cost-effective eye care accessible to all sections of society. His commitment to service is reflected through numerous community outreach programs, including government and private school screenings and eye camps for underprivileged children. A prolific contributor to medical science, he has also presented several research papers at national and international ophthalmology conferences.Surgeries, and Glaucoma interventions. Under his leadership, Divyadrishti Eye Hospital introduced cutting-edge, patient-friendly surgical techniques such as No Anesthesia, No Bandage, and Bloodless Cataract Surgeries, simplifying complex procedures and improving patient outcomes significantly.\nDr. Jain has been instrumental in making advanced, cost-effective eye care accessible to all sections of society. His commitment to service is reflected through numerous community outreach programs, including government and private school screenings and eye camps for underprivileged children. A prolific contributor to medical science, he has also presented several research papers at national and international ophthalmology conferences.",
        image:
          "https://img.pristyncare.com/Medical_Services_Dashboard/2025-05-07T08:55:10.719Z_Dr.-Prakash-Kumar-Jain-app 2.jpg/1746608111808_ban-Icon.png",
      },
      address_data: {
        id: "MWM1gjNzQj",
        city: "Bangalore",
        region_code: "560104",
        label_to_show: "1108/K, 9th C Main Rd, Vijayanagar, Bengaluru",
        map_link: "https://prstyn.care/ls/uxKWxGK",
        latitude: "12.9587967",
        longitude: "77.5352676",
        doctor_clinic_appointment_slug: "Dr.-Prakash-Kumar-Jain--MWM1gjNzQj",
      },
      central_number: "6366447380",
      experience_details: {
        experience: "28 Years Experience Overall",
      },
      qualification_details: {
        qualifications: [
          {
            degree: "MBBS",
            institute: "Silchar Medical College & Hospital Silchar",
            year: "1997",
          },
          {
            degree: "DNB ophthalmology",
            institute: "National Board of Examinations, New Delhi",
            year: "2004",
          },
        ],
      },
      is_visiting_doctor: true,
      is_active: true,
      diseases_covered: [
        "Eye Problem",
        "Macular Edema",
        "Pterygium",
        "Phaco Surgery",
        "Toric Lens",
        "Multifocal Lens",
        "Monofocal Lens",
        "Vitrectomy",
        "Intravitreal Injections",
        "Glaucoma Surgery",
        "Squint Surgery",
        "Cataract Surgery",
      ],
      is_his_hospital_doctor: false,
      employee_code: "DPC2255",
      his_hospital_ids: [],
      hospital_hotline_number: null,
      diseases_covered_slug: [
        "eye-problem",
        "macular-edema",
        "pterygium",
        "phaco-surgery",
        "toric-lens",
        "multifocal-lens",
        "monofocal-lens",
        "vitrectomy",
        "intravitreal-injections",
        "glaucoma",
        "squint",
        "cataract",
      ],
      categories_list: ["ophthalmology"],
      categoriesSlug_list: ["eye-specialists"],
      doctor_page_path: "/specialist/dr-prakash-kumar-jain-efrhosicrm/",
      alternate_category_slug: "ophthalmologist",
      specialist_category_slug: "eye-specialists",
      totalReviews: 0,
      aggregateDoctorRealRating: 4.6,
    },
  },
  {
    title: "Dr. Deependra Vikram Singh (3DyND2oYFW)",
    slug: "dr-deependra-vikram-singh-3dynd2oyfw",
    acfData: {
      id: "3DyND2oYFW",
      main_category: "Ophthalmologist",
      cities: [
        {
          ID: 1856,
          post_title: "DELHI",
          post_name: "delhi",
          cityname: "Delhi",
        },
      ],
      personal_details: {
        name: "Dr. Deependra Vikram Singh",
        heading: "MBBS, MD-Ophthlamology",
        fees: "500",
        rating: "4.6",
        speciality: "Ophthalmologist/ Eye Surgeon",
        about:
          "Dr. Deependra Vikram Singh is an expert and experienced Ophthalmologist and Eye Surgeon with an experience of 15+ years, and specializes in Opthalmalogy. He graduated and obtained his MBBS degree from Maharashtra Dayanand University, Rohtak in 1997, and then his postgraduate DO degree from All India Institute of Medical Sciences 2001. Currently, he is practicing at Pristyn Care Clinic in South Delhi. He is fluent in English and Hindi and provides compassionate care for all his patients to ensure complete recovery. He has been commended by his patients for his caring nature, hard working attitude, and willingness to be there for them - any time of day and night. He provides treatment for the following - Indian Monofocal Cataract, Lasik, Indian Multifocal Cataract, Foreign Monofocal Cataract, Foreign Multifocal Cataract, Squint, Trifocal Indian Cataract, Trifocal Foreign Cataract, Monofocal Indian Toric Cataract, Monofocal Foreign Toric Cataract, Multifocal Indian Toric Cataract, Multifocal Foreign Toric Cataract, Basic Monofocal Foreign Cataract, Trifocal Indian Toric Cataract, Trifocal Foreign Toric Cataract, Non Femto Standard/Prk. He is registered in the Indian Medical Registry with the license number 7707. He strives to provide advanced medical care in a comfortable and holistic environment for all patients coming to her for treatment.",
        image:
          "https://img.pristyncare.com/Medical_Services_Dashboard/2024-06-08T10:09:34.549Z_Dr_0026_Dr.-Deependra-Vikram-Singh.jpg/1717841374974_ban-Icon.png",
      },
      address_data: {
        id: "IWY0kDZ1cj",
        city: "Delhi",
        region_code: "122001",
        label_to_show:
          "Sheetla Hospital, New Railway Rd, near DSD Collage, Subhash Nagar, Sector 8, Gurugram, Haryana 122001",
        map_link: "https://g.co/kgs/e3NGHD7",
        latitude: "28.468049",
        longitude: "77.0256228",
        doctor_clinic_appointment_slug:
          "Dr.-Deependra-Vikram-Singh--IWY0kDZ1cj",
      },
      central_number: "8065417867",
      experience_details: {
        experience: "28 Years Experience Overall",
      },
      qualification_details: {
        qualifications: [
          {
            degree: "MBBS",
            institute: "Maharashtra Dayanand University, Rohtak",
            year: "1997",
          },
          {
            degree: "MD",
            institute: "All India Institute of Medical Sciences",
            year: "2001",
          },
        ],
      },
      is_visiting_doctor: true,
      is_active: true,
      diseases_covered: [
        "Eye Problem",
        "Macular Edema",
        "Keratoconus",
        "Pterygium",
        "Phaco Surgery",
        "PRK Lasik Surgery",
        "Toric Lens",
        "Contoura Vision",
        "SMILE LASIK Surgery",
        "Multifocal Lens",
        "Monofocal Lens",
        "ICL Surgery",
        "Femto LASIK Surgery",
        "Vitrectomy",
        "Intravitreal Injections",
        "Glaucoma Surgery",
        "Squint Surgery",
        "Lasik Surgery",
        "Lasik Eye Surgery",
        "Cataract Surgery",
      ],
      is_his_hospital_doctor: true,
      employee_code: "DPC1919",
      his_hospital_ids: ["AcgnkN9Bmz"],
      hospital_hotline_number: null,
      diseases_covered_slug: [
        "eye-problem",
        "macular-edema",
        "keratoconus",
        "pterygium",
        "phaco-surgery",
        "prk-lasik-surgery",
        "toric-lens",
        "contoura-vision",
        "smile-lasik-surgery",
        "multifocal-lens",
        "monofocal-lens",
        "icl-surgery",
        "femto-lasik-surgery",
        "vitrectomy",
        "intravitreal-injections",
        "glaucoma",
        "squint",
        "lasik",
        "lasik-eye-surgery",
        "cataract",
      ],
      categories_list: ["ophthalmology"],
      categoriesSlug_list: ["eye-specialists"],
      doctor_page_path: "/specialist/dr-deependra-vikram-singh-3dynd2oyfw/",
      alternate_category_slug: "ophthalmologist",
      specialist_category_slug: "eye-specialists",
      totalReviews: 1,
      aggregateDoctorRealRating: "5.0",
    },
  },
  {
    title: "Dr. Rajpal Govindrao Usnale (cmoIi6OvjN)",
    slug: "dr-rajpal-govindrao-usnale-cmoii6ovjn",
    acfData: {
      id: "cmoIi6OvjN",
      main_category: "Ophthalmologist",
      cities: [
        {
          ID: 1865,
          post_title: "MUMBAI",
          post_name: "mumbai",
          cityname: "Mumbai",
        },
      ],
      personal_details: {
        name: "Dr. Rajpal Govindrao Usnale",
        heading: "MBBS, DOMS",
        fees: "500",
        rating: "4.5",
        speciality: "Ophthalmologist",
        about:
          "Dr. Rajpal Govindrao Usnale is an expert and experienced Ophthalmologist with over 20 years of experience in ophthalmic surgery, laser treatments, and refractive procedures. He earned his medical degree from Bharati Vidyapeeth Medical College, Pune, followed by a postgraduate degree from Terna Medical College, Navi Mumbai. He further specialized in Laser LASIK Refractive Surgery through a fellowship at Sai Surya Netra Seva, Ahmednagar. Dr. Usnale has now joined Pristyn Care, where he continues to provide advanced eye care with a focus on precision and patient well-being.\n\nDr. Usnale has held key positions in leading institutions throughout his career. He served as a Lecturer at Terna Medical College from 2002 to 2012, shaping the next generation of medical professionals. He worked as a Consultant Ophthalmologist at NMMC Hospital, Vashi, from 2003 to 2012, and as an Honorary Consultant at Swami Sarvanand Hospital, Ulhasnagar, from 2004 to 2013. In 2008, he founded Sai Drishti Eye Hospital and Laser Center in collaboration with renowned eye specialist Dr. Prakash Kankaria. He also served as the Medical Director at Lions Superspeciality Eye Hospital, Chondi, Alibaug, providing expert care in complex ophthalmic cases.\n\nDr. Rajpal Govindrao Usnale is registered with the Indian Medical Registry. His extensive experience in cataract surgery, LASIK, and other advanced ophthalmic procedures, combined with his commitment to patient-centered care, makes him a trusted name in the field. Fluent in multiple languages, he ensures effective communication and personalized treatment for all his patients, striving to provide the highest standard of eye care. Currently he practices at Pristyn Care Clinic, Mumbai. ",
        image:
          "https://img.pristyncare.com/Medical_Services_Dashboard/2025-03-12T06:55:02.299Z_Dr.-Rajpal-Govindrao-Usnale-app 2.jpg/1741762502708_ban-Icon.png",
      },
      address_data: {
        id: "UDZhFTMkdj",
        city: "Mumbai",
        region_code: "400705",
        label_to_show: "Natraj Complex, near Sanpada Station, Navi Mumbai",
        map_link: "https://maps.app.goo.gl/p3xh2M5qzor5Uw1X8",
        latitude: "19.0601118",
        longitude: "73.0139587",
        doctor_clinic_appointment_slug:
          "Dr.-Rajpal-Govindrao-Usnale--UDZhFTMkdj",
      },
      central_number: "6366447449",
      experience_details: {
        experience: "26 Years Experience Overall",
      },
      qualification_details: {
        qualifications: [
          {
            degree: "MBBS",
            institute: "University of Pune",
            year: "1999",
          },
          {
            degree: "Diploma in Ophthalmology",
            institute: "The College of Physicians and Surgeons of Bombay",
            year: "2004",
          },
        ],
      },
      is_visiting_doctor: true,
      is_active: true,
      diseases_covered: [
        "Eye Problem",
        "Macular Edema",
        "Pterygium",
        "Phaco Surgery",
        "Toric Lens",
        "Multifocal Lens",
        "Monofocal Lens",
        "Vitrectomy",
        "Intravitreal Injections",
        "Glaucoma Surgery",
        "Squint Surgery",
        "Cataract Surgery",
      ],
      is_his_hospital_doctor: false,
      employee_code: "DPC2221",
      his_hospital_ids: [],
      hospital_hotline_number: null,
      diseases_covered_slug: [
        "eye-problem",
        "macular-edema",
        "pterygium",
        "phaco-surgery",
        "toric-lens",
        "multifocal-lens",
        "monofocal-lens",
        "vitrectomy",
        "intravitreal-injections",
        "glaucoma",
        "squint",
        "cataract",
      ],
      categories_list: ["ophthalmology"],
      categoriesSlug_list: ["eye-specialists"],
      doctor_page_path: "/specialist/dr-rajpal-govindrao-usnale-cmoii6ovjn/",
      alternate_category_slug: "ophthalmologist",
      specialist_category_slug: "eye-specialists",
      totalReviews: 0,
      aggregateDoctorRealRating: 4.6,
    },
  },
  {
    title: "Dr. Vijay Shaukatali Parbatani (xdw9EOAn6t)",
    slug: "dr-vijay-shaukatali-parbatani-xdw9eoan6t",
    acfData: {
      id: "xdw9EOAn6t",
      main_category: "Ophthalmologist",
      cities: [
        {
          ID: 1867,
          post_title: "PUNE",
          post_name: "pune",
          cityname: "Pune",
        },
      ],
      personal_details: {
        name: "Dr. Vijay Shaukatali Parbatani",
        heading: "MBBS, MS-Ophthalmology",
        fees: "500",
        rating: "4.5",
        speciality: "Ophthalmologist",
        about:
          "Dr. Vijay Parbatani is an expert and experienced Ophthalmologist with over 20 years of clinical and surgical experience in eye care and vision correction. He holds an MBBS degree along with a Diploma in Ophthalmic Medicine and Surgery (DOMS) and an MS in Ophthalmology. A highly skilled ophthalmic surgeon, Dr. Parbatani specializes in Cataract and LASIK laser procedures, Refractive Laser Surgery, and Medical Retina management. His precision in treating a range of vision disorders has made him one of the most sought-after eye specialists in Pune.\n\nDr. Parbatani is a board-certified ophthalmologist and an esteemed member of the All India Ophthalmological Society and the Pune Ophthalmological Society. He has received specialized training in LASIK and Refractive Surgery, with a special focus on techniques that eliminate the need for glasses or contact lenses. He has also contributed to several national and international peer-reviewed medical journals, reinforcing his standing in the academic and professional community. His areas of expertise extend to Glaucoma, Comprehensive Ophthalmology, and Laser-based treatments for Diabetic Retinopathy.\n\nWith a commitment to offering world-class ophthalmic care in New Pune, Dr. Vijay Parbatani combines advanced technology with a compassionate approach to deliver accurate diagnosis and effective treatment. He has earned a reputation for excellence in Cataract and Glaucoma surgeries, Refractive Corrections, and retinal laser therapies. Known for his patient-first attitude and clinical precision, Dr. Parbatani continues to provide holistic, high-quality eye care for individuals across all age groups.",
        image:
          "https://img.pristyncare.com/Medical_Services_Dashboard/2025-05-07T09:36:33.062Z_Dr. Vijay Shaukatali Parbatani.jpg/1746610594143_ban-Icon.png",
      },
      address_data: {
        id: "EjY2IjYxgj",
        city: "Pune",
        region_code: "411006",
        label_to_show: "3rd Floor, near Ramwadi Police, Kalyani Nagar,Pune",
        map_link: "https://maps.app.goo.gl/SoBqeY54q3saDTUU8",
        latitude: "18.5544119",
        longitude: "73.9056901",
        doctor_clinic_appointment_slug:
          "Dr.-Vijay-Shaukatali-Parbatani--EjY2IjYxgj",
      },
      central_number: "6366370234",
      experience_details: {
        experience: "25 Years Experience Overall",
      },
      qualification_details: {
        qualifications: [
          {
            degree: "MBBS",
            institute: "Gujarat University",
            year: "2000",
          },
          {
            degree: "MS - Ophthalmology",
            institute: "Gujarat University",
            year: "2002",
          },
        ],
      },
      is_visiting_doctor: true,
      is_active: true,
      diseases_covered: [
        "Eye Problem",
        "Macular Edema",
        "Pterygium",
        "Phaco Surgery",
        "Toric Lens",
        "Multifocal Lens",
        "Monofocal Lens",
        "Vitrectomy",
        "Intravitreal Injections",
        "Glaucoma Surgery",
        "Squint Surgery",
        "Cataract Surgery",
      ],
      is_his_hospital_doctor: false,
      employee_code: "DPC2254",
      his_hospital_ids: [],
      hospital_hotline_number: null,
      diseases_covered_slug: [
        "eye-problem",
        "macular-edema",
        "pterygium",
        "phaco-surgery",
        "toric-lens",
        "multifocal-lens",
        "monofocal-lens",
        "vitrectomy",
        "intravitreal-injections",
        "glaucoma",
        "squint",
        "cataract",
      ],
      categories_list: ["ophthalmology"],
      categoriesSlug_list: ["eye-specialists"],
      doctor_page_path: "/specialist/dr-vijay-shaukatali-parbatani-xdw9eoan6t/",
      alternate_category_slug: "ophthalmologist",
      specialist_category_slug: "eye-specialists",
      totalReviews: 0,
      aggregateDoctorRealRating: 4.6,
    },
  },
  {
    title: "Dr. Shanmuga Priya M (yjUON9YiJU)",
    slug: "dr-shanmuga-priya-m-yjuon9yiju",
    acfData: {
      id: "yjUON9YiJU",
      main_category: "Ophthalmologist",
      cities: [
        {
          ID: 1860,
          post_title: "CHENNAI",
          post_name: "chennai",
          cityname: "Chennai",
        },
      ],
      personal_details: {
        name: "Dr. Shanmuga Priya M",
        heading: "MBBS, MS-Ophthalmology",
        fees: "500",
        rating: "4.5",
        speciality: "Ophthalmologist",
        about:
          "Dr. Shanmuga Priya M is an expert and experienced Ophthalmologist with over 15 years of experience in comprehensive eye care. She specializes in cataract surgery, diabetic retinopathy evaluation, eyelid procedures, and the management of various ocular conditions including uveitis, keratitis, and glaucoma. She completed her MBBS from Osmania Medical College, Hyderabad, and pursued her MS in Ophthalmology at Sarojini Devi Eye Hospital under Gandhi Medical College from 2006 to 2009. She has now joined Pristyn Care in Chennai, where she continues to offer expert care using advanced diagnostic and surgical technologies.\nDr. Shanmuga Priya has previously worked with Vasan Eye Care, where she served from November 2009 to June 2019, gaining over a decade of hands-on experience in treating a wide range of eye conditions. She has performed over 100 Small Incision Cataract Surgeries (SICS), conducted diagnostic procedures such as applanation tonometry, gonioscopy, visual field testing, and A & B-scan ultrasonography, and managed post-operative recovery and ocular trauma cases. Her academic interest led to a paper presentation on diabetic retinopathy at the AP State Conference in 2009, and she has attended several national ophthalmology conferences including IIRSI and Reticon.\nShe is fluent in English, Tamil, Hindi, and Telugu, ensuring effective communication with patients across diverse backgrounds. Dr. Shanmuga Priya is registered with the Indian Medical Registry (registration number to be confirmed). At Pristyn Care, she remains committed to delivering ethical, precise, and compassionate eye care, helping patients restore and maintain their vision in a safe and comfortable environment.",
        image:
          "https://img.pristyncare.com/Medical_Services_Dashboard/2025-04-29T10:26:12.180Z_Dr.-Shanmuga-Priya-M-app 2.jpg/1745922372622_ban-Icon.png",
      },
      address_data: {
        id: "MzYwIWOxgj",
        city: "Chennai",
        region_code: "600083",
        label_to_show: "Sarvamangala Colony, Ashok Nagar, Chennai",
        map_link: "https://maps.app.goo.gl/T8aNxdMr9F5GVXTv6",
        latitude: "13.0385202",
        longitude: "80.2166264",
        doctor_clinic_appointment_slug: "Dr.-Shanmuga-Priya-M--MzYwIWOxgj",
      },
      central_number: "6366447413",
      experience_details: {
        experience: "23 Years Experience Overall",
      },
      qualification_details: {
        qualifications: [
          {
            degree: "MBBS",
            institute: "NTR University of Health Sciences, Andhra Pradesh ",
            year: "2002",
          },
          {
            degree: "MS - Ophthalmology",
            institute: "Dr. NTR University of Health Sciences, Andhra Pradesh ",
            year: "2009",
          },
        ],
      },
      is_visiting_doctor: true,
      is_active: true,
      diseases_covered: [
        "Eye Problem",
        "Macular Edema",
        "Pterygium",
        "Phaco Surgery",
        "Toric Lens",
        "Multifocal Lens",
        "Monofocal Lens",
        "Vitrectomy",
        "Intravitreal Injections",
        "Glaucoma Surgery",
        "Squint Surgery",
        "Cataract Surgery",
      ],
      is_his_hospital_doctor: false,
      employee_code: "DPC2251",
      his_hospital_ids: [],
      hospital_hotline_number: null,
      diseases_covered_slug: [
        "eye-problem",
        "macular-edema",
        "pterygium",
        "phaco-surgery",
        "toric-lens",
        "multifocal-lens",
        "monofocal-lens",
        "vitrectomy",
        "intravitreal-injections",
        "glaucoma",
        "squint",
        "cataract",
      ],
      categories_list: ["ophthalmology"],
      categoriesSlug_list: ["eye-specialists"],
      doctor_page_path: "/specialist/dr-shanmuga-priya-m-yjuon9yiju/",
      alternate_category_slug: "ophthalmologist",
      specialist_category_slug: "eye-specialists",
      totalReviews: 0,
      aggregateDoctorRealRating: 4.6,
    },
  },
  {
    title: "Dr. Vishal Vasant Maniar (DPJW3Bg0QF)",
    slug: "dr-vishal-vasant-maniar-dpjw3bg0qf",
    acfData: {
      id: "DPJW3Bg0QF",
      main_category: "Ophthalmologist",
      cities: [
        {
          ID: 1865,
          post_title: "MUMBAI",
          post_name: "mumbai",
          cityname: "Mumbai",
        },
      ],
      personal_details: {
        name: "Dr. Vishal Vasant Maniar",
        heading: "MBBS, DNB-Ophthalmology",
        fees: "500",
        rating: "4.5",
        speciality: "Ophthalmologist",
        about:
          "Dr. Vishal Maniar is a Ophthalmologist/ Eye Surgeon in Dadar West, Mumbai and has an experience of 17 years in this field. Dr. Vishal Maniar practices at Pristyn care Clinic, Mumbai. He completed MBBS from Maharashtra Universtity of Health Sciences, Nashik in 2005 and DNB - Ophthalmology from National Board of Examination, India in 2010. \n",
        image:
          "https://img.pristyncare.com/Medical_Services_Dashboard/2025-01-17T04:53:42.152Z_Dr.-Vishal-Vasant-Maniar_app 2.jpg/1737089622293_ban-Icon.png",
      },
      address_data: {
        id: "QjZmNTY4cj",
        city: "Mumbai",
        region_code: "421201",
        label_to_show: "Navare Plaza, opp. Ramnagar Chowky, Dombivli",
        map_link: "https://maps.app.goo.gl/7fWH14kdLDqKeHQX9",
        latitude: "19.2167841",
        longitude: "73.0871146",
        doctor_clinic_appointment_slug: "Dr.-Vishal-Vasant-Maniar--QjZmNTY4cj",
      },
      central_number: "8527488190",
      experience_details: {
        experience: "21 Years Experience Overall",
      },
      qualification_details: {
        qualifications: [
          {
            degree: "MBBS",
            institute: "Maharashtra University of Health Sciences, Nashik",
            year: "2004",
          },
          {
            degree: "DNB ophthalmology",
            institute: "National Board of Examinations, New Delhi",
            year: "2010",
          },
        ],
      },
      is_visiting_doctor: true,
      is_active: true,
      diseases_covered: [
        "Eye Problem",
        "Macular Edema",
        "Pterygium",
        "Phaco Surgery",
        "Toric Lens",
        "Multifocal Lens",
        "Monofocal Lens",
        "Vitrectomy",
        "Intravitreal Injections",
        "Glaucoma Surgery",
        "Squint Surgery",
        "Cataract Surgery",
      ],
      is_his_hospital_doctor: false,
      employee_code: "DPC2184",
      his_hospital_ids: [],
      hospital_hotline_number: null,
      diseases_covered_slug: [
        "eye-problem",
        "macular-edema",
        "pterygium",
        "phaco-surgery",
        "toric-lens",
        "multifocal-lens",
        "monofocal-lens",
        "vitrectomy",
        "intravitreal-injections",
        "glaucoma",
        "squint",
        "cataract",
      ],
      categories_list: ["ophthalmology"],
      categoriesSlug_list: ["eye-specialists"],
      doctor_page_path: "/specialist/dr-vishal-vasant-maniar-dpjw3bg0qf/",
      alternate_category_slug: "ophthalmologist",
      specialist_category_slug: "eye-specialists",
      totalReviews: 1,
      aggregateDoctorRealRating: "5.0",
    },
  },
  {
    title: "Dr. Kalpana (n6S5aowjiE)",
    slug: "dr-kalpana-n6s5aowjie",
    acfData: {
      id: "n6S5aowjiE",
      main_category: "Ophthalmologist",
      cities: [
        {
          ID: 1860,
          post_title: "CHENNAI",
          post_name: "chennai",
          cityname: "Chennai",
        },
      ],
      personal_details: {
        name: "Dr. Kalpana",
        heading: "MBBS, DLO",
        fees: "500",
        rating: "4.8",
        speciality: "Ophthalmologist/ Eye Surgeon",
        about:
          "Dr. Kalpana is an expert and experienced Ophthalmologist and Eye Surgeon with an experience of 20 years, and specializes in Opthalmalogy. She graduated and obtained her MBBS degree from The Tamil Nadu Dr. MGR University in 2004, and then her postgraduate DO degree from The Tamil Nadu Dr. MGR University 2009. Currently, she is practicing at Pristyn Care Clinic in Anna Nagar. She is fluent in English and Hindi and provides compassionate care for all her patients to ensure complete recovery. She has been commended by her patients for her caring nature, hard working attitude, and willingness to be there for them - any time of day and night. She provides treatment for the following - Indian Monofocal Cataract, Lasik, Indian Multifocal Cataract, Foreign Monofocal Cataract, Foreign Multifocal Cataract, Squint, Trifocal Indian Cataract, Trifocal Foreign Cataract, Monofocal Indian Toric Cataract, Monofocal Foreign Toric Cataract, Multifocal Indian Toric Cataract, Multifocal Foreign Toric Cataract, Basic Monofocal Foreign Cataract, Trifocal Indian Toric Cataract, Trifocal Foreign Toric Cataract, Non Femto Standard/Prk. She is registered in the Indian Medical Registry with the license number 75324. She strives to provide advanced medical care in a comfortable and holistic environment for all patients coming to her for treatment.",
        image:
          "https://img.pristyncare.com/Medical_Services_Dashboard/2024-06-08T10:33:37.365Z_Dr_0020_Dr.-Kalpana.jpg/1717842817810_ban-Icon.png",
      },
      address_data: {
        id: "YDNjVGZ1Uj",
        city: "Chennai",
        region_code: "600102",
        label_to_show: "3rd Ave, Block M, Annanagar East, Chennai",
        map_link:
          "https://www.google.com/maps/dir//Aradhana+eye+care+Hospital+M-5,+new,+77,+3rd+Ave,+Block+M,+Annanagar+East,+Chennai,+Tamil+Nadu+600102/data=!4m6!4m5!1m1!4e2!1m2!1m1!1s0x3a5264212ff08167:0x11cd95a1516fa1d6?sa=X&ved=2ahUKEwjSo8y9xNeCAxWcr1YBHV23DdkQ9Rd6BAg8EAA",
        latitude: "13.0931466",
        longitude: "80.2183258",
        doctor_clinic_appointment_slug: "Dr.-Kalpana--YDNjVGZ1Uj",
      },
      central_number: "7353240888",
      experience_details: {
        experience: "21 Years Experience Overall",
      },
      qualification_details: {
        qualifications: [
          {
            degree: "MBBS",
            institute: "The Tamil Nadu Dr. MGR University",
            year: "2004",
          },
          {
            degree: "Diploma in Ophthalmology",
            institute: "The Tamil Nadu Dr. MGR University",
            year: "2009",
          },
        ],
      },
      is_visiting_doctor: true,
      is_active: true,
      diseases_covered: [
        "Eye Problem",
        "Macular Edema",
        "Pterygium",
        "Phaco Surgery",
        "PRK Lasik Surgery",
        "Toric Lens",
        "Contoura Vision",
        "SMILE LASIK Surgery",
        "Multifocal Lens",
        "Monofocal Lens",
        "ICL Surgery",
        "Femto LASIK Surgery",
        "Vitrectomy",
        "Intravitreal Injections",
        "Glaucoma Surgery",
        "Squint Surgery",
        "Lasik Surgery",
        "Lasik Eye Surgery",
        "Cataract Surgery",
      ],
      is_his_hospital_doctor: false,
      employee_code: "DPC1896",
      his_hospital_ids: [],
      hospital_hotline_number: null,
      diseases_covered_slug: [
        "eye-problem",
        "macular-edema",
        "pterygium",
        "phaco-surgery",
        "prk-lasik-surgery",
        "toric-lens",
        "contoura-vision",
        "smile-lasik-surgery",
        "multifocal-lens",
        "monofocal-lens",
        "icl-surgery",
        "femto-lasik-surgery",
        "vitrectomy",
        "intravitreal-injections",
        "glaucoma",
        "squint",
        "lasik",
        "lasik-eye-surgery",
        "cataract",
      ],
      categories_list: ["ophthalmology"],
      categoriesSlug_list: ["eye-specialists"],
      doctor_page_path: "/specialist/dr-kalpana-n6s5aowjie/",
      alternate_category_slug: "ophthalmologist",
      specialist_category_slug: "eye-specialists",
      totalReviews: 1,
      aggregateDoctorRealRating: "5.0",
    },
  },
  {
    title: "Dr. Pramod Kumar H N (Yd4GK4xEgG)",
    slug: "dr-pramod-kumar-h-n-yd4gk4xegg",
    acfData: {
      id: "Yd4GK4xEgG",
      main_category: "Ophthalmologist",
      cities: [
        {
          ID: 1869,
          post_title: "BANGALORE",
          post_name: "bangalore",
          cityname: "Bangalore",
        },
      ],
      personal_details: {
        name: "Dr. Pramod Kumar H N",
        heading: "MBBS, MS-Ophthalmology",
        fees: "500",
        rating: "4.5",
        speciality: "Ophthalmologist",
        about:
          "Dr. Pramod Kumar H.N is a Ophthalmologist/ Eye Surgeon in Bangalore and has an experience of 15 years in this field. Dr. Pramod Kumar H.N practices at Pristyn Care Clinc, Bangalore. He completed MBBS from S N Medical College in 2010 and MS - Ophthalmology from Assam Medical College in 2014.",
        image:
          "https://img.pristyncare.com/Medical_Services_Dashboard/2025-01-14T13:19:23.530Z_Dr.-Pramod-Kumar-H.-N_app 2.jpg/1736860764141_ban-Icon.png",
      },
      address_data: {
        id: "QGNkR2NhRj",
        city: "Bangalore",
        region_code: "560100",
        label_to_show: "87/1, Hosur Rd, nr Bosch, Bluru, Karnataka",
        map_link: "",
        latitude: "12.87035",
        longitude: "77.6591142",
        doctor_clinic_appointment_slug: "Dr.-Pramod-Kumar-H-N--QGNkR2NhRj",
      },
      central_number: "8527488190",
      experience_details: {
        experience: "16 Years Experience Overall",
      },
      qualification_details: {
        qualifications: [
          {
            degree: "MBBS",
            institute: "Rajiv Gandhi University of Health Sciences, Karnataka",
            year: "2009",
          },
          {
            degree: "MS - Ophthalmology",
            institute:
              "Srimanta Sankaradeva University of Health Sciences Guwahati, Assam",
            year: "2014",
          },
        ],
      },
      is_visiting_doctor: true,
      is_active: true,
      diseases_covered: [
        "Eye Problem",
        "Macular Edema",
        "Pterygium",
        "Phaco Surgery",
        "Toric Lens",
        "Multifocal Lens",
        "Monofocal Lens",
        "Vitrectomy",
        "Intravitreal Injections",
        "Glaucoma Surgery",
        "Squint Surgery",
        "Cataract Surgery",
      ],
      is_his_hospital_doctor: false,
      employee_code: "DPC2181",
      his_hospital_ids: [],
      hospital_hotline_number: null,
      diseases_covered_slug: [
        "eye-problem",
        "macular-edema",
        "pterygium",
        "phaco-surgery",
        "toric-lens",
        "multifocal-lens",
        "monofocal-lens",
        "vitrectomy",
        "intravitreal-injections",
        "glaucoma",
        "squint",
        "cataract",
      ],
      categories_list: ["ophthalmology"],
      categoriesSlug_list: ["eye-specialists"],
      doctor_page_path: "/specialist/dr-pramod-kumar-h-n-yd4gk4xegg/",
      alternate_category_slug: "ophthalmologist",
      specialist_category_slug: "eye-specialists",
      totalReviews: 0,
      aggregateDoctorRealRating: 4.6,
    },
  },
  {
    title: "Dr. Sonalika Dubey (SEmRpfRIDQ)",
    slug: "dr-sonalika-dubey-semrpfridq",
    acfData: {
      id: "SEmRpfRIDQ",
      main_category: "Ophthalmologist",
      cities: [
        {
          ID: 1867,
          post_title: "PUNE",
          post_name: "pune",
          cityname: "Pune",
        },
      ],
      personal_details: {
        name: "Dr. Sonalika Dubey",
        heading: "MBBS, Diploma in Ophthalmic Medicine & surgery",
        fees: "500",
        rating: "4.5",
        speciality: "Ophthalmologist",
        about:
          "Dr. Sonalika Dubey is a skilled and experienced Ophthalmologist at Pristyn Care, Pune (Hadapsar). She will be available on-call, offering flexible consultation support.\nDr. Dubey specializes in the diagnosis and management of various eye disorders including cataracts, refractive errors, glaucoma, and retinal conditions. Her patient-first approach and clinical expertise ensure comprehensive and compassionate eye care.",
        image:
          "https://img.pristyncare.com/Medical_Services_Dashboard/2025-07-31T09:34:19.361Z_dr-sonalika-app.jpg/1753954460584_ban-Icon.png",
      },
      address_data: {
        id: "gDZkZGNlFj",
        city: "Pune",
        region_code: "411028",
        label_to_show:
          "1st Floor, Aru Palace, Malwadi Rd, near Mahalaxmi Mandir, Hadapsar, Pune, Maharashtra 411028",
        map_link: "https://maps.google.com/maps?cid=2919002572388813745",
        latitude: "18.5021256",
        longitude: "73.9336341",
        doctor_clinic_appointment_slug: "Dr.-Sonalika-Dubey--gDZkZGNlFj",
      },
      central_number: "8065105216",
      experience_details: {
        experience: "16 Years Experience Overall",
      },
      qualification_details: {
        qualifications: [
          {
            degree: "MBBS",
            institute: "Devi Ahilya Vishwavidyalaya, Indore",
            year: "2009",
          },
          {
            degree: "Diploma in Ophthalmology",
            institute: "The College of Physicians and Surgeons of Mumbai",
            year: "2012",
          },
        ],
      },
      is_visiting_doctor: true,
      is_active: true,
      diseases_covered: [
        "Eye Problem",
        "Macular Edema",
        "Keratoconus",
        "Pterygium",
        "Phaco Surgery",
        "Toric Lens",
        "Multifocal Lens",
        "Monofocal Lens",
        "Vitrectomy",
        "Intravitreal Injections",
        "Glaucoma Surgery",
        "Squint Surgery",
        "Cataract Surgery",
      ],
      is_his_hospital_doctor: true,
      employee_code: "DPC2295",
      his_hospital_ids: [],
      hospital_hotline_number: null,
      diseases_covered_slug: [
        "eye-problem",
        "macular-edema",
        "keratoconus",
        "pterygium",
        "phaco-surgery",
        "toric-lens",
        "multifocal-lens",
        "monofocal-lens",
        "vitrectomy",
        "intravitreal-injections",
        "glaucoma",
        "squint",
        "cataract",
      ],
      categories_list: ["ophthalmology"],
      categoriesSlug_list: ["eye-specialists"],
      doctor_page_path: "/specialist/dr-sonalika-dubey-semrpfridq/",
      alternate_category_slug: "ophthalmologist",
      specialist_category_slug: "eye-specialists",
      totalReviews: 0,
      aggregateDoctorRealRating: 4.6,
    },
  },
  {
    title: "Dr. Suresh Azimeera (qTRmezMEPK)",
    slug: "dr-suresh-azimeera-qtrmezmepk",
    acfData: {
      id: "qTRmezMEPK",
      main_category: "Ophthalmologist",
      cities: [
        {
          ID: 1876,
          post_title: "HYDERABAD",
          post_name: "hyderabad",
          cityname: "Hyderabad",
        },
      ],
      personal_details: {
        name: "Dr. Suresh Azimeera",
        heading: "MBBS, MD-Ophthalmology",
        fees: "500",
        rating: "4.6",
        speciality: "Ophthalmologist/Eye Surgeon",
        about:
          "Dr. Suresh Azimeera is an expert and experienced Ophthalmologist and Eye Surgeon, and specializes in Ophthalmology. He graduated and obtained his MBBS degree from RMC, KAKINADA, AP, NTRUHS in 2008, and then his postgraduate DO degree from Dr Rajendra Prasad Centre for Ophthalmic Sciences, AIIMS, New Delhi 2010. Currently, he is practicing at Pristyn Care Clinic in Hyderabad. He is fluent in English and Hindi and provides compassionate care for all his patients to ensure complete recovery. He has been commended by his patients for his caring nature, hard working attitude, and willingness to be there for them - any time of day and night. He provides treatment for the following - Indian Monofocal Cataract, Lasik, Indian Multifocal Cataract, Foreign Monofocal Cataract, Foreign Multifocal Cataract, Squint, Trifocal Indian Cataract, Trifocal Foreign Cataract, Monofocal Indian Toric Cataract, Monofocal Foreign Toric Cataract, Multifocal Indian Toric Cataract, Multifocal Foreign Toric Cataract, Basic Monofocal Foreign Cataract, Trifocal Indian Toric Cataract, Trifocal Foreign Toric Cataract, Non Femto Standard/Prk. He is registered in the Indian Medical Registry with the license number 73632. He strives to provide advanced medical care in a comfortable and holistic environment for all patients coming to her for treatment.",
        image:
          "https://img.pristyncare.com/Medical_Services_Dashboard/2024-11-27T14:35:33.110Z_Dr.-Suresh-Azimeera 2.jpg/1732718133540_ban-Icon.png",
      },
      address_data: {
        id: "YTZ0cTM2cj",
        city: "Hyderabad",
        region_code: "500049",
        label_to_show:
          "Plot No. 1 1st Floor, Sy. No. 225, H.No. 1-54/TP/1, Madeenaguda, Serilingampalle (M), Telangana 500049",
        map_link: "https://g.co/kgs/TTmdJXu",
        latitude: "17.4931473",
        longitude: "78.3435456",
        doctor_clinic_appointment_slug: "Dr.-Suresh-Azimeera--YTZ0cTM2cj",
      },
      central_number: "7353240999",
      experience_details: {
        experience: "15 Years Experience Overall",
      },
      qualification_details: {
        qualifications: [
          {
            degree: "MBBS",
            institute: "RMC, KAKINADA, AP, NTRUHS",
            year: "2010",
          },
          {
            degree: "MS - Ophthalmology",
            institute:
              "Dr Rajendra Prasad Centre for Ophthalmic Sciences, AIIMS, New  Delhi",
            year: "2018",
          },
        ],
      },
      is_visiting_doctor: true,
      is_active: true,
      diseases_covered: [
        "Eye Problem",
        "Macular Edema",
        "Keratoconus",
        "Pterygium",
        "Phaco Surgery",
        "PRK Lasik Surgery",
        "Toric Lens",
        "Contoura Vision",
        "SMILE LASIK Surgery",
        "Multifocal Lens",
        "Monofocal Lens",
        "ICL Surgery",
        "Femto LASIK Surgery",
        "Vitrectomy",
        "Intravitreal Injections",
        "Glaucoma Surgery",
        "Squint Surgery",
        "Lasik Surgery",
        "Lasik Eye Surgery",
        "Cataract Surgery",
      ],
      is_his_hospital_doctor: false,
      employee_code: "DPC2137",
      his_hospital_ids: [],
      hospital_hotline_number: null,
      diseases_covered_slug: [
        "eye-problem",
        "macular-edema",
        "keratoconus",
        "pterygium",
        "phaco-surgery",
        "prk-lasik-surgery",
        "toric-lens",
        "contoura-vision",
        "smile-lasik-surgery",
        "multifocal-lens",
        "monofocal-lens",
        "icl-surgery",
        "femto-lasik-surgery",
        "vitrectomy",
        "intravitreal-injections",
        "glaucoma",
        "squint",
        "lasik",
        "lasik-eye-surgery",
        "cataract",
      ],
      categories_list: ["ophthalmology"],
      categoriesSlug_list: ["eye-specialists"],
      doctor_page_path: "/specialist/dr-suresh-azimeera-qtrmezmepk/",
      alternate_category_slug: "ophthalmologist",
      specialist_category_slug: "eye-specialists",
      totalReviews: 0,
      aggregateDoctorRealRating: 4.6,
    },
  },
  {
    title: "Dr. Aftab Abdul Khader (NWeoCGhyf2)",
    slug: "dr-aftab-abdul-khader-nweocghyf2",
    acfData: {
      id: "NWeoCGhyf2",
      main_category: "Ophthalmologist",
      cities: [
        {
          ID: 1876,
          post_title: "HYDERABAD",
          post_name: "hyderabad",
          cityname: "Hyderabad",
        },
      ],
      personal_details: {
        name: "Dr. Aftab Abdul Khader",
        heading: "MBBS, MS-Ophthalmology",
        fees: "500",
        rating: "4.5",
        speciality: "Ophthalmologist",
        about:
          "Dr. Aftab Abdul Khader is an expert and experienced Ophthalmologist with over 15 years of experience. He earned his MBBS and MS in Ophthalmology from Dr. NTR University of Health Sciences. Dr. Khader has further honed his skills with specialized training in Refractive Surgery.\n\nThroughout his career, Dr. Khader has held significant positions in esteemed institutions. He served as a Refractive Surgeon at American Laser Eye Hospitals in Hyderabad, where he was recognized for his expertise in advanced laser eye surgeries. His commitment to patient care and surgical excellence has been acknowledged by both peers and patients alike.\n\nDr. Khader strives to provide advanced ophthalmic care in a comfortable and holistic environment, ensuring optimal outcomes for his patients. Dr. Khader is fluent in English, Hindi, and Telugu, enabling effective communication with a diverse patient population. He practices at Pristyn Care Clinic, Hyderabad. ",
        image:
          "https://img.pristyncare.com/Medical_Services_Dashboard/2025-02-11T13:35:47.597Z_Dr.-Aftab-Abdul-Khader_app 2.jpg/1739280948225_ban-Icon.png",
      },
      address_data: {
        id: "UmZycTM2cj",
        city: "Hyderabad",
        region_code: "500016",
        label_to_show: "Pillar 1335, Kura Towers, Begumpet, Hyderabad",
        map_link: "https://g.co/kgs/yHtaL7V",
        latitude: "17.4445368",
        longitude: "78.4699633",
        doctor_clinic_appointment_slug: "Dr.-Aftab-Abdul-Khader--UmZycTM2cj",
      },
      central_number: "6366447430",
      experience_details: {
        experience: "14 Years Experience Overall",
      },
      qualification_details: {
        qualifications: [
          {
            degree: "MBBS",
            institute: "Rajiv Gandhi University of Health Sciences, Karnataka",
            year: "2011",
          },
          {
            degree: "MS - Ophthalmology",
            institute: "Dr. NTR University of Health Sciences, Andhra Pradesh",
            year: "2017",
          },
        ],
      },
      is_visiting_doctor: true,
      is_active: true,
      diseases_covered: [
        "Eye Problem",
        "Macular Edema",
        "Pterygium",
        "Phaco Surgery",
        "Toric Lens",
        "Multifocal Lens",
        "Monofocal Lens",
        "Vitrectomy",
        "Intravitreal Injections",
        "Glaucoma Surgery",
        "Squint Surgery",
        "Cataract Surgery",
      ],
      is_his_hospital_doctor: false,
      employee_code: "DPC2212",
      his_hospital_ids: [],
      hospital_hotline_number: null,
      diseases_covered_slug: [
        "eye-problem",
        "macular-edema",
        "pterygium",
        "phaco-surgery",
        "toric-lens",
        "multifocal-lens",
        "monofocal-lens",
        "vitrectomy",
        "intravitreal-injections",
        "glaucoma",
        "squint",
        "cataract",
      ],
      categories_list: ["ophthalmology"],
      categoriesSlug_list: ["eye-specialists"],
      doctor_page_path: "/specialist/dr-aftab-abdul-khader-nweocghyf2/",
      alternate_category_slug: "ophthalmologist",
      specialist_category_slug: "eye-specialists",
      totalReviews: 1,
      aggregateDoctorRealRating: "5.0",
    },
  },
  {
    title: "Dr. Raksha H V (V4esni6y79)",
    slug: "dr-raksha-h-v-v4esni6y79",
    acfData: {
      id: "V4esni6y79",
      main_category: "Ophthalmologist",
      cities: [
        {
          ID: 1876,
          post_title: "HYDERABAD",
          post_name: "hyderabad",
          cityname: "Hyderabad",
        },
      ],
      personal_details: {
        name: "Dr. Raksha H V",
        heading: "MBBS, MS-Ophthalmology",
        fees: "500",
        rating: "4.5",
        speciality: "Ophthalmologist",
        about:
          "Dr. Raksha H V Jain is an expert and experienced Ophthalmologist with over 9 years of experience. She obtained her MBBS from Vijayanagar Institute of Medical Sciences, followed by a Master's degree in Ophthalmology from S Nijalingappa Medical College and H S K Hospital. She further specialized by completing a Fellowship in Cornea and Refractive Surgery (FICS) at Sankar Foundation Eye Hospital.\n\nThroughout her career, Dr. Jain has held significant positions in various esteemed institutions. She served as a Consultant at Sankar Foundation Eye Hospital in Visakhapatnam, Andhra Pradesh, from February 2021 to February 2024. Following this, she worked as a Cornea, Phaco, and Refractive Surgeon at Citi Eye Hospital in Hyderabad.\n\nDr. Jain is fluent in English and is known for her compassionate approach towards patient care. She is registered with the Karnataka Medical Council. Dr. Jain is committed to providing advanced ophthalmic care in a comfortable and holistic environment, ensuring the best possible outcomes for her patients. Currently She practices at Pristyn Care Clinic, Hyderabad. ",
        image:
          "https://img.pristyncare.com/Medical_Services_Dashboard/2025-02-12T12:34:07.305Z_Dr.-Raksha-H-V_app 2.jpg/1739363647765_ban-Icon.png",
      },
      address_data: {
        id: "Q2YhJDOidj",
        city: "Hyderabad",
        region_code: "500032",
        label_to_show: "Plot 102, Prashanti Hills, Khajaguda, Raidurgam",
        map_link: "https://maps.app.goo.gl/4tLeXxGjCAWvLJkTA",
        latitude: "17.4188881",
        longitude: "78.3821376",
        doctor_clinic_appointment_slug: "Dr.-Raksha-H-V--Q2YhJDOidj",
      },
      central_number: "6366447430",
      experience_details: {
        experience: "11 Years Experience Overall",
      },
      qualification_details: {
        qualifications: [
          {
            degree: "MBBS",
            institute: "Rajiv Gandhi University of Health Sciences, Karnataka",
            year: "2014",
          },
          {
            degree: "MS - Ophthalmology",
            institute: "Rajiv Gandhi University of Health Sciences, Karnataka",
            year: "2020",
          },
        ],
      },
      is_visiting_doctor: true,
      is_active: true,
      diseases_covered: [
        "Eye Problem",
        "Macular Edema",
        "Pterygium",
        "Phaco Surgery",
        "Toric Lens",
        "Multifocal Lens",
        "Monofocal Lens",
        "Vitrectomy",
        "Intravitreal Injections",
        "Glaucoma Surgery",
        "Squint Surgery",
        "Cataract Surgery",
      ],
      is_his_hospital_doctor: false,
      employee_code: "DPC2213",
      his_hospital_ids: [],
      hospital_hotline_number: null,
      diseases_covered_slug: [
        "eye-problem",
        "macular-edema",
        "pterygium",
        "phaco-surgery",
        "toric-lens",
        "multifocal-lens",
        "monofocal-lens",
        "vitrectomy",
        "intravitreal-injections",
        "glaucoma",
        "squint",
        "cataract",
      ],
      categories_list: ["ophthalmology"],
      categoriesSlug_list: ["eye-specialists"],
      doctor_page_path: "/specialist/dr-raksha-h-v-v4esni6y79/",
      alternate_category_slug: "ophthalmologist",
      specialist_category_slug: "eye-specialists",
      totalReviews: 1,
      aggregateDoctorRealRating: "5.0",
    },
  },
  {
    title: "Dr. Hemali Pratik Doshi (kC1creP67l)",
    slug: "dr-hemali-pratik-doshi-kc1crep67l",
    acfData: {
      id: "kC1creP67l",
      main_category: "Ophthalmologist",
      cities: [
        {
          ID: 1865,
          post_title: "MUMBAI",
          post_name: "mumbai",
          cityname: "Mumbai",
        },
      ],
      personal_details: {
        name: "Dr. Hemali Pratik Doshi",
        heading: "MBBS, MS-Ophthalmology",
        fees: "500",
        rating: "4.5",
        speciality: "Ophthalmologist",
        about:
          "Dr. Hemali Pratik Doshi is an expert and experienced Ophthalmologist with over 10 years of clinical experience in diagnosing and treating a wide range of eye disorders and vision problems. She has joined Pristyn Care in Ghatkopar, Mumbai, as a Visiting Consultant. Dr. Doshi is known for her precision in clinical assessment, patient-friendly consultations, and commitment to delivering high-quality eye care.\nShe completed her MBBS followed by specialization in Ophthalmology and has gained valuable experience working with reputed eye hospitals and clinics. Her areas of expertise include cataract evaluation, refractive errors, glaucoma screening, dry eye management, and minor ophthalmic procedures. Dr. Hemali is dedicated to improving visual health and provides evidence-based care tailored to each patient’s condition and lifestyle needs.",
        image:
          "https://img.pristyncare.com/Medical_Services_Dashboard/2025-07-17T11:22:43.688Z_Dr.-Hemali-Pratik-Doshi-app.jpg/1752751364150_ban-Icon.png",
      },
      address_data: {
        id: "",
        city: "Mumbai",
        region_code: "",
        label_to_show: "",
        map_link: "",
        latitude: "",
        longitude: "",
      },
      central_number: "8065105113",
      experience_details: {
        experience: "11 Years Experience Overall",
      },
      qualification_details: {
        qualifications: [
          {
            degree: "MBBS",
            institute: "VEER NARMAD SOUTH GUJARAT UNIVERSITY",
            year: "2014",
          },
          {
            degree: "MS - Ophthalmology",
            institute: "VEER NARMAD SOUTH GUJARAT UNIVERSITY",
            year: "2019",
          },
        ],
      },
      is_visiting_doctor: true,
      is_active: true,
      diseases_covered: [
        "Eye Problem",
        "Macular Edema",
        "Keratoconus",
        "Pterygium",
        "Phaco Surgery",
        "Toric Lens",
        "Multifocal Lens",
        "Monofocal Lens",
        "Vitrectomy",
        "Intravitreal Injections",
        "Glaucoma Surgery",
        "Squint Surgery",
        "Cataract Surgery",
      ],
      is_his_hospital_doctor: false,
      employee_code: "DPC2267",
      his_hospital_ids: [],
      hospital_hotline_number: null,
      diseases_covered_slug: [
        "eye-problem",
        "macular-edema",
        "keratoconus",
        "pterygium",
        "phaco-surgery",
        "toric-lens",
        "multifocal-lens",
        "monofocal-lens",
        "vitrectomy",
        "intravitreal-injections",
        "glaucoma",
        "squint",
        "cataract",
      ],
      categories_list: ["ophthalmology"],
      categoriesSlug_list: ["eye-specialists"],
      doctor_page_path: "/specialist/dr-hemali-pratik-doshi-kc1crep67l/",
      alternate_category_slug: "ophthalmologist",
      specialist_category_slug: "eye-specialists",
      totalReviews: 0,
      aggregateDoctorRealRating: 4.6,
    },
  },
  {
    title: "Dr. Akanksha Thakkar (ZAwBB1rUNG)",
    slug: "dr-akanksha-thakkar-zawbb1rung",
    acfData: {
      id: "ZAwBB1rUNG",
      main_category: "Ophthalmologist",
      cities: [
        {
          ID: 1867,
          post_title: "PUNE",
          post_name: "pune",
          cityname: "Pune",
        },
      ],
      personal_details: {
        name: "Dr. Akanksha Thakkar",
        heading: "MBBS, DNB",
        fees: "800",
        rating: "4.5",
        speciality: "Opthalmologist",
        about:
          "Dr. Akanksha Batra is a Ophthalmologist / Eye Surgeon in Dattawadi, Pune and has an experience of 10 years as a medical practitioner. Dr. Akanksha Batra practices at Pristyn Care Clinic in Dattawadi, Pune.",
        image:
          "https://img.pristyncare.com/our%20doctors%2FAvatar%2FAkankshaShyamThakkar.jpg",
      },
      address_data: {
        id: "YjY5QjNzQj",
        city: "Pune",
        region_code: "411004",
        label_to_show: "Lajwanti Apts, Opp Sonal Hall, Karve Rd, Pune",
        map_link: "https://prstyn.care/ls/ERaCGgN",
        latitude: "18.5052854",
        longitude: "73.8336924",
        doctor_clinic_appointment_slug: "Dr.-Akanksha-Thakkar--YjY5QjNzQj",
      },
      central_number: "6366370234",
      experience_details: {
        experience: "10 Years Experience Overall",
      },
      qualification_details: {
        qualifications: [
          {
            degree: "",
            institute: "",
            year: "2012",
          },
        ],
      },
      is_visiting_doctor: true,
      is_active: true,
      diseases_covered: [
        "Eye Problem",
        "Macular Edema",
        "Pterygium",
        "Phaco Surgery",
        "PRK Lasik Surgery",
        "Toric Lens",
        "Contoura Vision",
        "SMILE LASIK Surgery",
        "Multifocal Lens",
        "Monofocal Lens",
        "ICL Surgery",
        "Femto LASIK Surgery",
        "Vitrectomy",
        "Intravitreal Injections",
        "Glaucoma Surgery",
        "Squint Surgery",
        "Lasik Surgery",
        "Lasik Eye Surgery",
        "Cataract Surgery",
      ],
      is_his_hospital_doctor: false,
      employee_code: "DPC526",
      his_hospital_ids: [],
      hospital_hotline_number: null,
      diseases_covered_slug: [
        "eye-problem",
        "macular-edema",
        "pterygium",
        "phaco-surgery",
        "prk-lasik-surgery",
        "toric-lens",
        "contoura-vision",
        "smile-lasik-surgery",
        "multifocal-lens",
        "monofocal-lens",
        "icl-surgery",
        "femto-lasik-surgery",
        "vitrectomy",
        "intravitreal-injections",
        "glaucoma",
        "squint",
        "lasik",
        "lasik-eye-surgery",
        "cataract",
      ],
      categories_list: ["ophthalmology"],
      categoriesSlug_list: ["eye-specialists"],
      doctor_page_path: "/specialist/dr-akanksha-thakkar-zawbb1rung/",
      alternate_category_slug: "ophthalmologist",
      specialist_category_slug: "eye-specialists",
      totalReviews: 3,
      aggregateDoctorRealRating: "5.0",
    },
  },
];
